import { logger as E } from "../../shared-lib/index.js";
export function setLogger(e) {
  E.setLogger(e);
}